import { BulkUpdateUsageConditions, mapBulkUpdateUsageConditionsToApi } from '../bulkUpdateUsageConditions';
import { selectionlistConfig } from '../../config';
import { invalidateSelectionListAggregations } from '../../shop/selectionlists/useSelectionListAggregations';
import { copiesListUsageConditionUpdate } from '../../store/copiesList/actions';
import { invalidateSelectionListSummary } from './useSelectionListSummary';
import { invalidateSelectionListProducts } from '../../shop/selectionlists/api/useSelectionListProducts';
import { log } from '../../shared/utils/log';
import { useDispatch } from 'react-redux';
import { http } from '../axios';
import { globalErrorResponse, isErrorOfType } from '../../store/notifications/actions';
import { invalidateSelectionListGroupedItems } from './useSelectionListGroupedItems';

export function useBulkUpdateUsageConditions(listId: string) {
    const dispatch = useDispatch();

    return async (updates: BulkUpdateUsageConditions) => {
        const jsonBody = mapBulkUpdateUsageConditionsToApi(updates);

        try {
            await http.put(selectionlistConfig().bulkUpdateUsageConditions, jsonBody, {
                pathParams: { listId },
                requestGroup: 'productList' // axios.interceptor
            });

            invalidateSelectionListAggregations(listId).then();
            dispatch(copiesListUsageConditionUpdate(updates.map(update => update.productId)));
            invalidateSelectionListSummary(listId).then();
            invalidateSelectionListProducts(listId).then();
            invalidateSelectionListGroupedItems(listId).then();
        } catch (error) {
            log.error(error, { causedBy: 'products/actions -> bulkUpdateUsageConditionsInList' });
            if (isErrorOfType(error)) {
                dispatch(globalErrorResponse(error));
            }
        }
    };
}
